import PrivateRoute from "./PrivateRoute";
import { Routes as DomReoutes, Route } from "react-router-dom";
import { readAccessToken } from "../common/functions/authFunctions";
import HomePage from "../pages/HomePage";
import { AllPage } from "../pages/equipment/AllPage";
import { MainPage } from "../pages/MainPage";
import { LoginPage } from "../pages/auth/LoginPage";
import { DrivePage } from "../pages/data/db/DrivePage";

import { SensorPage } from "../pages/analysis/SensorPage";
import { BackupPage } from "../pages/setting/user/BackupPage";
import { StatusPage } from "../pages/support/alarm/StatusPage";
import { TechDocPage } from "../pages/support/TechDocPage";
import { AccountPage } from "../pages/setting/user/AccountPage";
import { AccessLogPage } from "../pages/setting/user/AccessLogPage";
import { Generator01Page } from "../pages/equipment/Generator01Page";
import { Generator02Page } from "../pages/equipment/Generator02Page";
import { Generator03Page } from "../pages/equipment/Generator03Page";
import { Generator04Page } from "../pages/equipment/Generator04Page";
import { EquipmentInfoPage } from "../pages/setting/EquipmentInfoPage";
import { DataMonitoringPage } from "../pages/data/manage/DataMonitoringPage";
import { Helmet } from "react-helmet";
import { AuthPage } from "../pages/setting/user/AuthPage";
import { MainEngine01Page } from "../pages/equipment/MainEngine01Page";
import { MainEngine02Page } from "../pages/equipment/MainEngine02Page";
import { MainEngine03Page } from "../pages/equipment/MainEngine03Page";
import { MainEngine04Page } from "../pages/equipment/MainEngine04Page";
import { TrendPage } from "../pages/analysis/TrendPage";

interface RouterItem {
  path: string;
  element: React.ReactNode;
  withAuthorization: boolean;
  title?: string;
}

const routerItems: RouterItem[] = [
  /* 메인화면 */
  { path: "/auth/login", element: <LoginPage />, withAuthorization: false },
  { path: "/", element: <HomePage />, withAuthorization: true },

  /* 장비 모니터링 */
  {
    path: "/equipment/all",
    element: <AllPage />,
    withAuthorization: true,
    title: "장비 모니터링 > 장비 운용현황",
  },
  {
    path: "/equipment/generator01/:index",
    element: <Generator01Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.1 발전기",
  },
  {
    path: "/equipment/generator02/:index",
    element: <Generator02Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.2 발전기",
  },
  {
    path: "/equipment/generator03/:index",
    element: <Generator03Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.3 발전기",
  },
  {
    path: "/equipment/generator04/:index",
    element: <Generator04Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.4 발전기",
  },
  {
    path: "/equipment/mainengine01/:index",
    element: <MainEngine01Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.1 메인엔진",
  },
  {
    path: "/equipment/mainengine02/:index",
    element: <MainEngine02Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.2 메인엔진",
  },
  {
    path: "/equipment/mainengine03/:index",
    element: <MainEngine03Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.3 메인엔진",
  },
  {
    path: "/equipment/mainengine04/:index",
    element: <MainEngine04Page />,
    withAuthorization: true,
    title: "장비 모니터링 > No.4 메인엔진",
  },

  /* 데이터 분석 */
  {
    path: "/analysis/trend",
    element: <TrendPage />,
    withAuthorization: true,
    title: "데이터 분석 > 동일시간 차트 분석",
  },
  {
    path: "/analysis/sensor",
    element: <SensorPage />,
    withAuthorization: true,
    title: "데이터 분석 > 센서 데이터 조회",
  },

  /* 데이터 통합관리 */
  {
    path: "/data/manage/monitoring",
    element: <DataMonitoringPage />,
    withAuthorization: true,
    title: "데이터 통합관리 > 데이터 관리 > 송・수신 모니터링",
  },
  // {
  //   path: "/data/manage/log",
  //   element: <DataLogPage />,
  //   withAuthorization: true,
  //   title: "데이터 통합관리 > 데이터 관리 > 데이터 로그",
  // }, // 데이터 로그 주석처리
  {
    path: "/data/db/drive",
    element: <DrivePage />,
    withAuthorization: true,
    title: "데이터 통합관리 > DB 관리 > 저장소 관리",
  },

  /* 정비지원 */
  {
    path: "/support/alarm/status",
    element: <StatusPage />,
    withAuthorization: true,
    title: "정비지원 > 함정 알람 관리 > 상태진단 알람",
  },
  {
    path: "/support/tech-doc",
    element: <TechDocPage />,
    withAuthorization: true,
    title: "정비지원 > 기술문서 관리",
  },

  /* 관리자 설정 */
  {
    path: "/setting/equipment-info",
    element: <EquipmentInfoPage />,
    withAuthorization: true,
    title: "관리자 설정 > 장비 정보관리",
  },
  {
    path: "/setting/user/account",
    element: <AccountPage />,
    withAuthorization: true,
    title: "관리자 설정 > 사용자 관리 > 계정 관리",
  },
  {
    path: "/setting/user/auth",
    element: <AuthPage />,
    withAuthorization: true,
    title: "관리자 설정 > 사용자 관리 > 권한 관리",
  },
  {
    path: "/setting/user/access-log",
    element: <AccessLogPage />,
    withAuthorization: true,
    title: "관리자 설정 > 사용자 관리 > 접속로그 관리",
  },
  {
    path: "/setting/user/backup",
    element: <BackupPage />,
    withAuthorization: true,
    title: "관리자 설정 > 사용자 관리 > DB 백업 설정",
  },
];

export function Routes() {
  const accessToken = readAccessToken();

  return (
    <DomReoutes>
      <Route element={<MainPage />}>
        {routerItems
          .filter((route) => route.withAuthorization)
          .map((route: RouterItem) => {
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <>
                    <Helmet>
                      <title>
                        {route.title ?? "함정 상태기반 정비 지원체계(해상)"}
                      </title>
                    </Helmet>
                    <PrivateRoute
                      component={route.element}
                      authenticated={accessToken}
                    />
                  </>
                }
              />
            );
          })}
      </Route>

      {routerItems
        .filter((route) => !route.withAuthorization)
        .map((route: RouterItem) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
    </DomReoutes>
  );
}
